import { useState } from "react";
import SectionHeading from "@/components/feature/SectionHeading";
import { faqs } from "@/mocks/events";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto max-w-content px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[0.85fr_1.15fr] lg:gap-12">
          <div>
            <SectionHeading
              eyebrow="常见问题"
              title="关于热搜吃瓜事件梳理"
              desc="如果你对内容来源、更新方式或订阅节奏有疑问，先看这里。还有问题，欢迎在关于我们页面留言。"
            />
            <div className="rounded-lg border border-secondary-200 bg-secondary-100 p-5">
              <p className="flex items-center gap-2 font-heading text-sm font-semibold text-secondary-900">
                <i className="ri-shield-check-line text-lg"></i>
                内容原则
              </p>
              <p className="mt-2.5 text-sm leading-relaxed text-secondary-900/80">
                只整理公开可查的信息，标注时间与状态；不确定的细节不写成结论，也不替当事人下判断。
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((faq, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={faq.q}
                  className="overflow-hidden rounded-lg border border-background-200 bg-background-50"
                >
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-4 text-left md:px-5"
                      aria-expanded={isOpen}
                    >
                      <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                        {faq.q}
                      </span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md transition-colors ${
                          isOpen
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        <i
                          className={isOpen ? "ri-subtract-line" : "ri-add-line"}
                        ></i>
                      </span>
                    </button>
                  </h3>
                  {isOpen && (
                    <p className="border-t border-background-200 px-4 py-4 text-sm leading-relaxed text-foreground-600 md:px-5">
                      {faq.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}